import { TemplatePage } from './types';

const fitnessPage: TemplatePage = {
  header: {
    color: '#E8B6B9',
    icon: 'images/video-templates/fitnes-wellness.jpg',
    title: 'Sports & Fitness Video Templates Collection',
    title_meta: '50+ Free and Customizable Fitness Video Templates',
    description_meta:
      'Create dynamic and motivating videos with Wave.video’s 50+ customizable video templates crafted for the sports ' +
      'and fitness industry.',
    description:
      'Motivate, encourage and inspire your sport-loving audience with videos. Promote sports events, fitness apps or ' +
      'online training classes with these 50+ customizable video templates. Make dynamic videos full of energy and joy.'
  },
  footer: {
    category: 'Sports & Fitness',
    description:
      'Wave.video offers a wide range of sports-related video templates that you can turn into your hyping branded ' +
      'content. Grab the one you like, replace the sample footage, fine-tune the message right in place and get your ' +
      'ready-to-share sports and fitness video.'
  },
  content: [
    {
      type: 'templates',
      title: 'sport and fitness',
      search: { category: '/Industries/Sport & Wellness' }
    },
    {
      type: 'stocks',
      title: 'fitness and wellness',
      search: { name: 'fitness' }
    },
    { type: 'calendar' }
  ]
};

export default fitnessPage;
